import * as React from "react";
import {formatDateTime, getAmountWithDecimalDigits} from "../../CommonFunctions";
import {PREMIUM_TYPE_MONTHLY} from "@ferry/journey-services";
import {Link} from "react-router-dom";
import {InfoBanner} from "@ferry/portal-core";

interface IMigratedRenewalInvitationBannerProps {
    interaction: any;
}

interface IMigratedRenewalInvitationBannerState {
    displayInfoMessage: boolean;
}

export class MigratedRenewalInvitationBanner extends React.Component<IMigratedRenewalInvitationBannerProps, IMigratedRenewalInvitationBannerState> {

    constructor(props: IMigratedRenewalInvitationBannerProps) {
        super(props);

        this.state = {
            displayInfoMessage: false
        };
    }

    public render() {
        const vehicle: any = this.props.interaction?.vehicles[0];
        const premiumType: string = this.props.interaction?.factors?.premiumType;

        return (
            <InfoBanner wording={
                <>
                    <p>You have not yet accepted your renewal invitation.</p>
                    <p><strong>
                        Set up your renewal
                        for{" "}{vehicle?.make} {vehicle?.model} from {formatDateTime(this.props.interaction?.headerInfo.startDate)} {' '}
                        for {getAmountWithDecimalDigits(premiumType === PREMIUM_TYPE_MONTHLY
                        ? this.props.interaction?.factors?.monthlyPremium
                        : this.props.interaction?.factors?.annualPremium)}
                        {premiumType === PREMIUM_TYPE_MONTHLY && <span>/month</span>}
                    </strong>
                    </p>
                    <div className="row mt-2">
                        <div className="col-12">
                            <div className="mt-2">
                                <Link type="button"
                                      to={`/journey/show/product/AnnualMotorInsurance/process/nb/summary/${this.props.interaction._id}`}
                                      className="btn btn-transparent-white m-auto">Set up your renewal now
                                </Link>
                            </div>
                        </div>
                    </div>
                </>
            }/>
        )
    }
}


